import React, { memo } from 'react';
import styled from 'styled-components';
import { FieldInputProps } from 'react-final-form';

import useBoolean from '@front/common/src/hooks/use-boolean';

import iconButton from '../button/icon-button';
import Input, { InputProps } from '../input/input';

const StyledIconButton = styled(iconButton)`
  position: absolute;
  right: 20px;
  top: 14px;
  z-index: 20;
`;

const PasswordContainer = styled.div`
  position: relative;
  width: 100%;
`;

type InputPasswordPropsLegacy = FieldInputProps<HTMLInputElement> &
  Omit<InputProps, 'iconName'> & { isErrorDisplay?: boolean; showsErrorsOnMount?: boolean };

const InputPasswordLegacy = React.forwardRef<HTMLInputElement, InputPasswordPropsLegacy>(
  ({ input, meta, showsErrorsOnMount, isErrorDisplay = true, ...rest }, ref) => {
    const { value: isVisible, toggle: togglePasswordVisibility } = useBoolean(false);

    return (
      <PasswordContainer>
        <Input
          {...input}
          {...rest}
          type={isVisible ? 'text' : 'password'}
          error={isErrorDisplay && (meta?.touched || showsErrorsOnMount) && meta.error ? meta.error : undefined}
          ref={ref}
        />
        <StyledIconButton
          type='infodark'
          label='show password'
          iconName={isVisible ? 'unshow' : 'show'}
          onPress={togglePasswordVisibility}
          iconSize={20}
        />
      </PasswordContainer>
    );
  },
);

export type { InputProps };
export default memo(InputPasswordLegacy);
